import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/constants/routes'
import { STORAGE_KEYS } from '@/constants/auth'
import { useAuth } from '@/contexts/authContext'
import { authService } from '@/services/auth'

export function PaymentSuccessPage() {
  const { t } = useTranslation('wizard')
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { refreshAuth } = useAuth()
  const token = searchParams.get('token')
  const hasToken = Boolean(token)
  const promoApplied = searchParams.get('promo_applied') === 'true'
  const promoCodeFreeMonths = Number(searchParams.get('promo_code_free_months')) || 0
  const showPromoMessage = promoApplied && promoCodeFreeMonths > 0

  useEffect(() => {
    if (token) {
      localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token)
      refreshAuth()
    }
  }, [token, refreshAuth])

  const handleFinish = () => {
    navigate(hasToken || authService.isAuthenticated() ? ROUTES.DASHBOARD : ROUTES.HOME)
  }

  return (
    <div className="bg-background flex min-h-0 flex-1 flex-col items-center justify-center px-4 py-8">
      <div className="mx-auto max-w-[500px]">
        <div className="rounded-[26px] border border-[#E9E9E9] bg-white px-[54px] py-10">
          <div className="mb-4 flex justify-center">
            <img src="/check.svg" alt="" width={60} height={60} className="h-[60px] w-[60px]" />
          </div>
          <h1 className="text-foreground mb-4 text-center text-xl font-bold">
            {t('paymentSuccess.title')}
          </h1>
          <p className="text-foreground mb-4 text-center text-base font-normal">
            {t('paymentSuccess.subtitle')}
          </p>
          {showPromoMessage && (
            <p className="mb-6 text-center text-sm font-normal text-[#41B95D]">
              {t('paymentSuccess.promoCodeApplied', { count: promoCodeFreeMonths })}
            </p>
          )}
          <div className="mt-6 flex justify-center">
            <button
              type="button"
              onClick={handleFinish}
              className="bg-primary text-primary-foreground rounded-md px-10 py-2.5 text-sm font-semibold transition-opacity hover:opacity-90"
            >
              {t('paymentSuccess.finishButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
